export const textStyles = {
    fontSize: ["mobileBodyTextNormal", "desktopBodyTextNormal"],
    fontWeight: "bold",
};

export const summaryStyles = {
    header: {
        ...textStyles,
        textTransform: "uppercase",
        pb: 8,
    },
    text: {
        ...textStyles,
        mb: 0,
    },
    tooltipHeader: {
        ...textStyles,
        mb: 4,
        textTransform: "uppercase",
    },
    tooltipText: {
        fontSize: ["mobileBodyTextNormal", "desktopBodyTextNormal"],
    },
    divider: {
        my: 6,
        borderColor: "gray.200",
    },
};
